<template>
  <aside class="admin-sidebar" :class="{ open: isOpen }">
    <div class="brand">
      <div class="brand-mark">OA</div>
      <div>
        <strong>Academy Admin</strong>
        <span>Content dashboard</span>
      </div>
    </div>
    <nav class="sidebar-nav">
      <router-link to="/logs" @click="$emit('navigate')">
        <span class="nav-icon"><span class="fas fa-chart-line"></span></span>
        <span class="nav-label">Dashboard</span>
      </router-link>

      <router-link to="/categories" @click="$emit('navigate')">
        <span class="nav-icon"><span class="fas fa-tags"></span></span>
        <span class="nav-label">Категории</span>
      </router-link>

      <router-link v-for="item in visibleCollectionNav" :key="item.to" :to="item.to" @click="$emit('navigate')">
        <span class="nav-icon"><span :class="`fas ${item.icon}`"></span></span>
        <span class="nav-label">{{ item.label }}</span>
      </router-link>
      <div class="nav-group">
        <button class="nav-group-toggle" type="button" @click="toggleGroup('pages')">
          <span class="nav-icon"><span class="fas fa-file-alt"></span></span>
          <span class="nav-label">Страницы</span>
          <span class="fas fa-chevron-down nav-chevron" :class="{ open: openedGroups.pages }"></span>
        </button>
        <div class="nav-sublist" v-show="openedGroups.pages">
          <router-link v-for="item in pageNav" :key="item.to" :to="item.to" @click="$emit('navigate')">
            {{ item.label }}
          </router-link>
        </div>
      </div>
    </nav>
    <div class="sidebar-language">
      <LanguageSwitcher />
    </div>
    <div ref="userDropdown" class="dropup user-box sidebar-user-box motion-dropdown">
      <button class="user-box-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <span class="user-box-avatar">
          <img v-if="authUserImage" :src="authUserImage" :alt="authUserEmail">
          <span v-else>{{ authUserInitials }}</span>
        </span>
        <span class="user-box-meta">
          <strong>{{ authUserName || authUserEmail }}</strong>
          <small>{{ authUserRole }}</small>
        </span>
        <span class="fas fa-chevron-up"></span>
      </button>
      <div class="dropdown-menu user-box-menu motion-dropdown-menu">
        <router-link class="dropdown-item" to="/settings" @click="$emit('navigate')">
          <span class="fas fa-cog"></span>
          Настройки
        </router-link>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item text-danger" type="button" @click="$emit('logout')">
          <span class="fas fa-sign-out-alt"></span>
          Logout
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import Dropdown from 'bootstrap/js/dist/dropdown'
import LanguageSwitcher from './LanguageSwitcher.vue'

const DROPDOWN_MOTION_MS = 160

export default {
  components: {
    LanguageSwitcher
  },
  emits: ['logout', 'navigate'],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    authUserEmail: {
      type: String,
      default: ''
    },
    authUserName: {
      type: String,
      default: ''
    },
    authUserRole: {
      type: String,
      default: ''
    },
    authUserImage: {
      type: String,
      default: ''
    },
    authUserInitials: {
      type: String,
      default: 'A'
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropdownMotionTimer: null,
      isDropdownClosing: false,
      openedGroups: {
        pages: false
      },
      pageNav: [
        { to: '/pages/general', label: 'Общее' },
        { to: '/pages/home', label: 'Главная' },
        { to: '/pages/about', label: 'О нас' },
        { to: '/pages/courses', label: 'Курсы' },
        { to: '/pages/events', label: 'Мероприятия' },
        { to: '/pages/blogs', label: 'Блог' },
        { to: '/pages/team', label: 'Команда' },
        { to: '/pages/contacts', label: 'Контакты' },
        { to: '/pages/profile', label: 'Профиль' },
        { to: '/pages/additional', label: 'Дополнительные страницы' }
      ],
      collectionNav: [
        { to: '/users', label: 'Пользователи', icon: 'fa-user-shield', adminOnly: true },
        { to: '/applications', label: 'Заявки', icon: 'fa-inbox' },
        { to: '/feedback', label: 'Обратная связь', icon: 'fa-comments' },
        { to: '/collections/courses', label: 'Курсы', icon: 'fa-graduation-cap' },
        { to: '/collections/started-courses', label: 'Запущенные курсы', icon: 'fa-clipboard-check' },
        { to: '/collections/test-bank', label: 'Банк тестов', icon: 'fa-tasks' },
        { to: '/collections/events', label: 'Мероприятия', icon: 'fa-calendar-alt' },
        { to: '/collections/blogs', label: 'Блог', icon: 'fa-newspaper' },
        { to: '/collections/team', label: 'Команда', icon: 'fa-users' }
      ]
    }
  },
  computed: {
    visibleCollectionNav() {
      return this.collectionNav.filter(item => !item.adminOnly || this.$store.getters.isAdmin)
    }
  },
  methods: {
    handleDropdownHide(event) {
      const dropdown = this.$refs.userDropdown
      const menu = dropdown ? dropdown.querySelector('.dropdown-menu') : null

      if (!menu || this.isDropdownClosing) {
        return
      }

      event.preventDefault()
      menu.classList.add('is-closing')

      clearTimeout(this.dropdownMotionTimer)
      this.dropdownMotionTimer = setTimeout(() => {
        this.isDropdownClosing = true
        Dropdown.getOrCreateInstance(dropdown.querySelector('[data-bs-toggle="dropdown"]')).hide()
        this.isDropdownClosing = false
        menu.classList.remove('is-closing')
      }, DROPDOWN_MOTION_MS)
    },
    toggleGroup(groupKey) {
      this.openedGroups[groupKey] = !this.openedGroups[groupKey]
    }
  },
  mounted() {
    this.$refs.userDropdown.addEventListener('hide.bs.dropdown', this.handleDropdownHide)
  },
  beforeUnmount() {
    clearTimeout(this.dropdownMotionTimer)
    this.$refs.userDropdown.removeEventListener('hide.bs.dropdown', this.handleDropdownHide)
  }
}
</script>
